import React, {Component} from 'react';
import PropTypes from 'prop-types';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import '../assets/css/all.css';
import logo from "../assets/img/logo-white.png";

import ContentHeaderContainer from "../containers/General/ContentHeaderContainer";
import SidebarContainer from "../containers/General/SidebarContainer";

import {Redirect, Route, Switch} from "react-router-dom";

import VideoContainer from "../containers/Video/VideoContainer";
import ChatContainer from '../containers/Chat/ChatContainer';
import InPersonSessionContainer from "../containers/UserCourse/InPersonSessionContainer";
import StudentProfileContainer from "../containers/StudentProfile/StudentProfileContainer";

import ChallengesContainer from "../containers/Challenges/ChallengesContainer";
import SettingsContainer from '../containers/Settings/SettingsContainer';
import DashboardAdminContainer from '../containers/Dashboard/DashboardAdmin/DashboardAdminContainer';
import OnBoardingContainer from "../containers/OnBoarding/OnBoardingContainer";
import VideoItemContainer from "../containers/Video/VideoItemContainer";
import DashboardContainer from "../containers/Dashboard/DashboardUser/DashboardContainer";
import TaskContainer from '../containers/TaskContainer';

import StudentProgressContainer from '../containers/StudentProfile/StudentProgressContainer';
import EditChapterPartContainer from "../containers/EditChapterPart/EditChapterPartContainer";
import CourseAdminContainer from "../containers/AdminPanel/CoursesAdminContainer";
import SettingsAdminContainer from '../containers/AdminPanel/SettingsAdminContainer';
import PeopleManager from './AdminPanel/People/PeopleManager';
import NotFound from './Generals/NotFound';
import StrategyManagementContainer from '../containers/AdminPanel/Strategy/StrategyManagmentContainer';
import EditChapterTestContainer from '../containers/AdminPanel/EditChapterTestContainer';
import EditTestContainer from '../containers/AdminPanel/EditTestContainer';
import MyTestsContainer from '../containers/UserCourse/MyTestsContainer';
import Notifications from '../containers/Dashboard/DashboardUser/NotificationContainer';
import Flags from '../containers/Dashboard/DashboardUser/FlagContainer';
import VerifyContainer from '../containers/VerifyContainer';
import Logs from './StudentProfile/Logs';
import Users from './Users';
import Loader from './Loader';
import About from './Common/About';
import TestContainer from '../containers/UserCourse/TestContainer';
import VideoScore from './Video/VideoScore';
import Syllabus from './Common/Syllabus';
import AdminConsole from './AdminConsole/AdminConsole';

import jwt from 'jsonwebtoken';


/**
 *
 */
 
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, socket: this.props.socket };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }


  componentDidCatch(error, errorInfo) {
    this.setState({ error });

  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
          
        return (
                <div
                id="container"
                className={"wrapper mainnav-out skin-blue sidebar-mini fixed sidebar-collapse"}
            >
            
                
                    <div className="content-wrapper" id="content-container">
                        <div id="app-error">
                        <i className="zmdi zmdi-mood-bad error-icon" />
                        <h1>It's not you, it's me!</h1>
                        <p>Something went wrong and I crashed.  It's probably not something you did.  To help get you back on track here are some helpful ideas:</p>
                        
                        <div className="help-buttons">
                            <button className="btn btn-primary" onClick={e => {
                                window.location.href = window.location.href;
                            }}>Reload this page</button>
                            <button className="btn btn-default" onClick={e => {
                                window.localStorage.clear();
                                window.location.href = '/login';
                            }}>Log Out (and then log in again)</button>
                            
                            
                            <p>If you continue to experience this issue, please <a href="#nogo" onClick={e => {
                                e.preventDefault();
                                
                                    let data = jwt.sign({
                                      command: {
                                      type: 'SEND_ERROR',
                                        error: this.state.error,
                                        user: this.props.user,
                                        url: window.location.href,
                                        
                                      token: this.props.user.id
                                    }}, '#&r7%+UbWU8Hc');
                                    if(this.state.socket){
                                        this.state.socket.send(data);
                                    }
                                    this.setState({issueReported: true});
                                    
                                    NotificationManager.success("This issue has been reported.");
                                
                                
                            }}>report it to us</a><br /><br />
                            
                            For support reach out to <a href="mailto:sohaib@99point9prep.com">sohaib@99point9prep.com</a> or at <a href="tel:6478990337">1 (647) 899-0337</a>
                            </p>
                        </div>
                        </div>
                    </div>
                    <About />
                    
                </div>
                )
    }

    return this.props.children; 
    
  }
}

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            socket: null,
            currentThread: null,
            currentMessageThread: {},
            content: '',
            issueReport: '',
            issueReported: false,
            socketCounter: 0,
            connectingCounter: 0,
            connectedTimer: null,
            connectedCounter: 0,
            attempts: 0
        }

        this.connectingTimer = null;
        this.socketTimer = null;
    }
    updateConnectedTimer = () => {

    }
    
    updateConnectionTimer = () => {
        if(this.state.socket){

        
            if(this.state.socket.readyState === 2){
                clearInterval(this.connectingTimer);
                
                this.setState({connectingTimer: null, connectingCounter: 0});
            }else if([2, 3].indexOf(this.state.socket.readyState) > -1 && !this.socketTimer){
                this.socketTimer = setInterval(this.updateTimer, 1000);
                clearInterval(this.connectingTimer);
                this.connectingTimer = null;
                
                this.setState({socketCounter: 15, connectingCounter: 0, attempts: this.state.attempts + 1});
            }else{
                if(this.state.connectingCounter === 0 && !this.socketTimer){
                    this.socketTimer = setInterval(this.updateTimer, 1000);
                    clearInterval(this.connectingTimer);
                    this.connectingTimer = null;
                    this.setState({socketCounter: 15, connectingCounter: 0, attempts: this.state.attempts + 1});
                }else{
                    this.setState({connectingCounter: this.state.connectingCounter - 1});
                }
            }
        }
    }
    
    setupSocket = () => {
        let self = this;
        let host = '';
        
        if(!this.connectingTimer){
            this.connectingTimer = setInterval(this.updateConnectionTimer, 1000);
        
            this.setState({connectingCounter: 5});
        }
        
        if(process.env.NODE_ENV == "development"){
            host = "ws://localhost:15454";
            //host = "wss://socket.99point9.ca";
        }else{
            host = "wss://socket.99point9.ca";
            //host = "http://clients.nickgermaine.com:3000/api/";
            //host = "wss://99socket.nickgermaine.com";
        }

        if(this.state.socket){
            if(this.state.socket.readyState === 1){
                return false;
            }
        }

      const socket = new WebSocket(host)
    
      socket.onopen = () => {
        let browser = "Other";
        let ua = navigator.userAgent;
        window.localStorage.clear();
        let cid = null;

        if(this.props.courseUser[0]){
            if(this.props.courseUser[0].courseId){
                cid = this.props.courseUser[0].courseId;
            }
        }
        if(ua.indexOf("Edge") > -1){
            browser = "Edge";
        }else if(ua.indexOf("IE") > -1) {
            browser = "IE";
        }else if(ua.indexOf("Chrome") > -1){
                browser = "Chrome";

        }else if(ua.indexOf("Safari") > -1){
            browser = "Safari";
        }else if(ua.indexOf("Firefox") > -1){
            browser = "Firefox";
        }
          let data = jwt.sign({
              command: {
              type: 'ADD_USER',
              name: "ME ADDING",
              courseId: cid,
              id: self.props.user.user.Profile.id,
              role: self.props.user.user.Profile.role,
              token: self.props.user.id,
              browser: browser,
            }}, '#&r7%+UbWU8Hc');
        socket.send(data)
      }
      
      socket.onclose = () => {

        this.socketTimer = setInterval(this.updateTimer, 1000);
        clearInterval(this.connectingTimer);
        clearInterval(this.socketTimer);

        this.setState({socketCounter: 60, connectingCounter: 0, attempts: this.state.attempts + 1});
      }
      
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data)
        switch (data.type) {
            case 'SUBJECT_ORDER_UPDATED':
                if(this.props.profile.role === 'student'){
                    self.props.updateCourseUser(data.cu);
                }else{
                    self.props.updateAdminCourseUser(data.cu);
                }
                    
                // If student, update the video cu,

                // If admin, update in adminInfo
                break;
          case 'MESSAGE_ADDED':
            
            self.props.addMessage(data.message);
            if(data.message.seenBy && data.message.threadId === self.state.currentThread){
                if(data.message.profileId !== self.props.user.user.Profile.id){
                    // console.log("Seenby?", data.message.seenBy, self.props.profile.id);
                    if(Object.keys(data.message.seenBy).indexOf(self.props.profile.id)){
                        
                        let command = jwt.sign({
                          command: {
                            type: 'MESSAGE_SEEN',
                            messageId: data.message.id,
                            profileId: self.props.user.user.Profile.id,
                            when: new Date(),
                            token: self.props.user.id
                  
                        }}, '#&r7%+UbWU8Hc');
                        this.state.socket.send(command)
                    }
                }

                
                self.props.resetUnread(data.message.threadId);
            }else if(data.message.profileId !== self.props.user.user.Profile.id){
                self.props.addToUnreadCount(data.message.threadId);
            }
            
            if(document.getElementsByClassName('chat-items-wrapper').length > 0){

                setTimeout(function(){

                    if(self.props.location.pathname.indexOf(data.message.threadId) > -1){

                       document.getElementsByClassName('chat-items-wrapper')[0].scroll({
                          top: document.getElementsByClassName('chat-items-wrapper')[0].scrollHeight, 
                          left: 0, 
                          behavior: 'smooth' 
                        });
                    }
                }, 200);
            }
            
            break;
        case 'LOADED_MORE_MESSAGES':
            if(data.messages.length > 0){
            self.props.prependMessages(data.messages);
            data.messages.map(msg => {
                
                if(msg.seenBy && msg.threadId === self.state.currentThread){
                    if(msg.profileId !== self.props.user.user.Profile.id){
                        // console.log("SEEN?", msg.seenBy, self.props.profile.id, self.props.user.user.Profile.id);
                        if(Object.keys(msg.seenBy).indexOf(self.props.profile.id) === -1){
                            
                            let command = jwt.sign({
                              command: {
                                type: 'MESSAGE_SEEN',
                                messageId: msg.id,
                                profileId: self.props.user.user.Profile.id,
                                when: new Date(),
                                token: self.props.user.id
                      
                            }}, '#&r7%+UbWU8Hc');
                            this.state.socket.send(command)
                        
                        }
                    }
                }
                return true;
                
                
            })
            }
            
            if(data.initial){
                if(document.getElementsByClassName('chat-items-wrapper').length > 0){
                    setTimeout(function(){
                        if(document.getElementsByClassName('chat-items-wrapper')[0]){
                           document.getElementsByClassName('chat-items-wrapper')[0].scroll({
                              top: document.getElementsByClassName('chat-items-wrapper')[0].scrollHeight, 
                              left: 0, 
                              behavior: 'smooth' 
                            });
                        }        
                    }, 1000);
                }
            }

            break;
        case 'STATUS_CHANGE':
            self.props.handleStatusChange(data, this.props.user.user.Profile.id);
            break;
        case 'THREAD_CREATED':
            if(data.thread.createdBy === this.props.profile.id){
                self.props.threadCreated(data.thread, true);
            }else{
                self.props.threadCreated(data.thread, false);
            }
            break;
        case 'INITIAL_THREADS':
            self.props.setInitialThreads(data.threads, this.props.user.id);
            self.props.settingsUpdated(data);
            self.props.initialTasks(data.tasks);
            break;
        case 'TICKET_THREADS':
            //self.props.setTicketThreads(data.threads);
            break;
            
        case 'TICKET_CREATED':
            if(this.props.profile.role === 'student' && this.props.profile.id === data.thread.createdBy){
                this.props.threadCreated(data.thread, true);
            }else{
                // Just push to threads, no auto redirect...
                this.props.threadCreated(data.thread, false);
            }
            break;
        case 'IS_TYPING':
            self.props.setIsTyping(data);
            break;
        case 'LOADED_THREAD_FILES':
            self.props.loadedThreadFiles(data);
            break;
        case 'MESSAGE_SEEN':
            self.props.setSeen(data);
            break;
        case 'THREAD_UPDATED':
            self.props.threadUpdated(data.thread, this.props.user.user.Profile.id);
            break;
        case 'TICKET_SOLVED':
            self.props.ticketSolved(data.thread, this.props.user.user.Profile.id);
            break;
        case 'TICKET_CLOSED':
            self.props.ticketClosed(data.thread, this.props.user.user.Profile.id);
            break;
        case 'THREAD_FIELD_UPDATED':
            self.props.threadFieldUpdated(data);
            break;
        case 'MESSAGE_UPDATED':
            self.props.messageUpdated(data);
            break;
        case 'REPORTED_COMMENTS_GOT':
            self.props.loadedReportedComments(data);
            break;
        case 'REPORT_SOLVED':
            self.props.resolveReport(data);
            break;
        case 'FILE_DELETED':
            self.props.deleteAttachment(data);
            break;
        case 'GOT_ATTACHMENTS':
            self.props.loadedAttachments(data);
            break;
        case 'GOT_INSTRUCTORS':
            self.props.loadedInstructors(data);
            break;
        case 'ANNOUNCEMENT_ADDED':
            self.props.announcementAdded(data);
            break;
        case 'ADDED_CU_NOTE':
            self.props.addedCuNote(data.note);
            break;
        case 'EDITED_CU_NOTE':
            self.props.editedCuNote(data.note);
            break;
        case 'DELETED_CU_NOTE':
            self.props.deletedCuNote(data.note);
            break;
        case 'ANNOUNCEMENTS_LOADED':
            self.props.loadedAnnouncements(data);
            break;
        case 'ANNOUNCEMENT_DELETED':
            self.props.announcementDeleted(data);
            break;
        case 'SETTINGS_UPDATED':
            self.props.settingsUpdated(data);
            break;
        case 'COURSE_STATUS_UPDATED':
            self.props.updateCourseStatus(data);
            break;
        case 'NOTIFICATION_ADDED':
            self.props.updateCourseNotifications(data);
        case 'FLAG_ADDED':
            self.props.updateFlags(data);
            break;
        case 'TASK_UPDATED':
            self.props.updateTask(data);
            break;
        case 'DISCUSSION_ADDED':
            self.props.addDiscussion(data.discussion);
            break;
        case 'COMMENT_ADDED':
            self.props.addComment(data.discussion);
            break;
        case 'TASK_ADDED':
            self.props.addTask(data);
            break;
        case 'LIKE_ADDED':
            self.props.postLike(data.like);
            break;
        case 'LIKE_REMOVED':
            self.props.deleteLike(data.like);
            break;
        case 'FOLLOW_ADDED':
            self.props.postFollow(data.follow);
            break;
        case 'FOLLOW_REMOVED':
            self.props.deleteFollow(data.follow);
            break;
        case 'EDITED_COURSEUSER':
            self.props.updateCourseUser(data.cu);
            break;
        case 'EDITED_USERLECTURE':
            if(self.props.user.user.Profile.role === 'admin'){
                self.props.updatedAdminUserLecture(data.ul);
            }else{
                self.props.updatedUserLecture(data.ul);
            }
            break;
        case 'ADDED_USERLECTURE':
            if(self.props.user.user.Profile.role === 'admin'){
                self.props.addedAdminUserLecture(data.ul);
            }else{
                self.props.addedUserLecture(data.ul);
            }
            break;
        case 'DELETED_QUIZ':
            if(self.props.user.user.Profile.role === 'admin'){
                self.props.deletedAdminQuiz(data.userLectureId);
            }else{
                self.props.deletedQuiz(data.userLectureId);
            }
            break;
        case 'REMOVED_USERLECTURE':
            if(self.props.user.user.Profile.role === 'admin'){
                self.props.removedAdminUserLecture(data.userLectureId);
            }else{
                self.props.removedUserLecture(data.userLectureId);
            }
            break;
        case 'LOGOUT_NOW':
            self.props.logout();
            break;
          default:
            break;
        }
      }
    
      return socket
    }
    
    componentDidMount(){
        this.setState({socket: this.setupSocket()});
    }

    componentWillUnmount(){
        clearInterval(this.connectingTimer);
        clearInterval(this.socketTimer);
        this.connectingTimer = null;
        this.socketTimer = null;
    }
    
    updateTimer = () => {
        if(this.state.socketCounter === 0){
            clearInterval(this.socketTimer);
            this.socketTimer = null;
            this.setState({socket: this.setupSocket()});
        }else{
            this.setState({socketCounter: this.state.socketCounter - 1});
        }
    }
    
    componentDidUpdate(props, state){
        if(props.courseUser != this.props.courseUser){
            let updateSocketCourse = false;
            
            if(props.courseUser[0] && this.props.courseUser[0]){
                // If update is occuring from having a cu to a diff one
                if(props.courseUser[0].id !== this.props.courseUser[0].id){
                    updateSocketCourse = true;
                }
            }else if(!props.courseUser[0] && this.props.courseUser[0]){
                updateSocketCourse = true;
            }

            if(updateSocketCourse){
                if(this.props.profile){
                    if(this.props.profile.role === 'student'){
                        // console.log("UPDATED CU");
                        let command = jwt.sign({
                            command: {
                              type: 'CHANGE_COURSE',
                              courseId: this.props.courseUser[0].courseId,
                              when: new Date(),
                              token: this.props.user.id
                    
                          }}, '#&r7%+UbWU8Hc');
                          this.state.socket.send(command)
                    }
                }
                
            }
        }
        if([2, 3].indexOf(this.state.socket.readyState) > -1 && !this.socketTimer && this.state.attempts <= 3){
            this.socketTimer = setInterval(this.updateTimer, 1000);

            this.setState({socketCounter: 60});
        }else if((this.socketTimer || this.connectingTimer) && (this.state.socket.readyState === 1)){
            clearInterval(this.socketTimer);
            clearInterval(this.connectingTimer);
            this.connectingTimer = null;
            this.socketTimer = null;
            this.setState({socketCounter: 0, connectingCounter: 0});
        }else if(this.state.attempts > 3 && this.state.socketCounter !== 999){
            clearInterval(this.socketTimer);
            clearInterval(this.connectingTimer);
            this.connectingTimer = null;
            this.socketTimer = null;
            this.setState({socketCounter: 999, connectingCounter: 0});
        }
    }

    render(){

            
            if(!this.props.user.user.emailVerified){
                return (
                    <div
                        id="container"
                        className={"wrapper mainnav-out skin-blue sidebar-mini fixed sidebar-collapse"}
                    >
                        <ContentHeaderContainer {...this.props} />
                        
                        
                        
                        <Switch>
                            <Route
                                exact
                                path="/"
                                render={
                                    (props) => {
                                        // Add verfication redirect 
                                        return <Redirect
                                            to='/verify'
                                            component={VerifyContainer}
                                        />
                                    }
                                }
                            />
                            
                            <Route
                                exact
                                path="/login"
                                render={
                                    (props) => {
                                        // Add verfication redirect 
                                        return <Redirect
                                            to='/verify'
                                            component={VerifyContainer}
                                        />
                                    }
                                }
                            />
                            
                            <Route
                                path="/verify/:token/:email" 
                                render={(props) => <VerifyContainer {...props} />}
                                />
                            
                            <Route
                                path="/verify/:token" 
                                render={(props) => <VerifyContainer {...props} />}
                                />
                                
                                
                                
                            <Route
                                path="/verify" 
                                render={(props) => <VerifyContainer {...props} />}
                                />
                                
                            <Route path = "*" render={() => {
                                return <Redirect to="/verify" component={VerifyContainer} /> 
                                
                            }} />
                            
                        </Switch>
                        
                        <NotificationContainer/>
        
                        <footer className="main-footer" id="footer">
                            <div className="pull-right hidden-xs footer-rightside"> <a href="#nogo">Terms of Service</a> | <a href="#nogo">Privacy Policy</a></div>
                            <span>
                            	<img src={logo} className="footerLogo" />
                            	<span className="footer-rightside">
                            		Copyright © 2019  99point9, Inc.
                            		All rights reserved.
                            	</span>
                            </span>
                        </footer>
                    </div>
            
                    )
            }
            
        return (
            <div
                id="container"
                className={"wrapper mainnav-out skin-blue sidebar-mini fixed sidebar-collapse"}
            >
                {
                    this.state.socket ?
                        this.state.socket.readyState === 2 || this.state.socket.readyState === 3 ?
                            this.state.socketCounter === 999 ?
                            <div className="alert alert-danger socket-alert" onClick={e => {
                                this.setState({socket: this.setupSocket()});
                            }}>
                                <i className="zmdi zmdi-close" /> &nbsp; You have lost connection to the server.  It looks like we can't automatically reconnect you.  Click here to reconnect.
                                
                            </div>
                            :
                            <div className="alert alert-danger socket-alert" onClick={e => {
                                this.setState({socket: this.setupSocket()});
                            }}>
                                <i className="zmdi zmdi-close" /> &nbsp; You have lost connection to the server.  Some features may not work correctly until we can reconnect you.  Click here to reconnect.
                                {this.state.attempts > 3 ?
                                    <div className="">Tip: Try refreshing this page?</div>
                                : null}
                            </div>
                        : null
                    : null
                }
                
                {
                    this.state.socket ?
                    this.state.socket.readyState === 0 ?
                    <div className="alert alert-warning socket-alert">
                        <i className="zmdi zmdi-refresh" /> &nbsp; Connecting...
                    </div>
                    : null
                    : null
                }
                
                {
                    this.state.socket ?
                    this.state.socket.readyState === 1 && this.state.connectedCounter > 0 ?
                    <div className="alert alert-success socket-alert">
                        <i className="zmdi zmdi-check" /> &nbsp; Connected!
                    </div>
                    : null
                    : null
                }
                <ContentHeaderContainer {...this.props} takeTour={(profile, token) => this.props.takeTour(profile, token)} />
                
                <SidebarContainer {...this.props} />
                <ErrorBoundary {...this.props} socket={this.state.socket}>

                <div className={`${this.state.socket ? [2, 3].indexOf(this.state.socket.readyState) > -1 ? '' : '' : ''}`}>
                <Switch>
                
                    <Route
                        path="/verify"
                        render={() => {
                            if (this.props.user.user.role === "instructor" || this.props.user.user.role === "admin") {
                                    return (
                                        <Redirect
                                            to='/dashboard-admin'
                                            
                                        />
                                    )
                                } else {
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )

                                }
                        }}
                        />
                
                    <Route
                        exact
                        path="/login"
                        render={
                            () => {
                                if (this.props.user.user.role === "instructor" || this.props.user.user.role === "admin") {
                                    return (
                                        <Redirect
                                            to='/dashboard-admin'
                                        />
                                    )
                                } else {
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )

                                }
                            }
                        }
                    />
                    
                    

                    <Route
                        exact
                        path="/signup"
                        render={
                            () => (
                                <Redirect
                                    to="/dashboard"
                                    component={DashboardContainer}
                                />
                            )
                        }
                    />

                    <Route
                        exact
                        path="/"
                        render={
                            () => {
                                if (this.props.user.user.role === "instructor" || this.props.user.user.role === "admin") {
                                    return (
                                        <Redirect
                                            to='/dashboard-admin'
                                        />
                                    )
                                } else {
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )

                                }
                            }
                        }
                    />
                   <Route
                        path='/dashboard/:courseId'
                        render={(props) => (
                        
                            <DashboardContainer {...props} socket={this.state.socket} />
                            
                            )
                        }
                    />
                    <Route
                        path='/dashboard'
                        render={(props) => (
                        
                            <DashboardContainer {...props} socket={this.state.socket} />
                            
                            )
                        }
                    />

                    <Route
                        path='/admin/:courseId/:view'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <AdminConsole {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }} />

                    <Route
                        path='/admin/:view'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <AdminConsole {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }} />

                    <Route
                        path='/admin'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <AdminConsole {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }} />

                    <Route
                        path='/dashboard-admin/:courseId'
                        exact={true}
                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                    return (
                                        <DashboardAdminContainer {...props} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    <Route
                        path='/dashboard-admin'
                        exact={true}
                        render={
                            () => {
                                if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                    return (
                                        <DashboardAdminContainer />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    
                    
                    <Route
                        path='/chat/admin/:view/:subjectId'
                        render={(match) => {
                        
                            return (
                                        <ChatContainer {...match} socket={this.state.socket} />
                                    )
                            }
                        }
                    />
                    
                    <Route
                        path='/chat/admin/:view'
                        render={(match) => {
         
                                    if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                        return (
                                            <ChatContainer {...match} socket={this.state.socket} />
                                        )
                                    }else{
                                        return (
                                            <Redirect
                                                to="/dashboard"
                                                component={DashboardContainer}
                                            />
                                        )
                                    }
                                
                            
                            }
                        }
                    />
                    
                     <Route
                        path='/chat/user/:profileId'
                        render={(match) => {
                        
                            return (
                                        <ChatContainer {...match} socket={this.state.socket} />
                                    )
                            }
                        }
                    />
                    
                    
                    <Route
                        path='/chat/:threadId/:subjectId'
                        render={(match) => {
                        
                            return (
                                        <ChatContainer {...match} socket={this.state.socket} />
                                    )
                            }
                        }
                    />
                    
                    <Route
                        path='/chat/:threadId'
                        render={(match) => {
                        
                            return (
                                        <ChatContainer {...match} socket={this.state.socket} resetUnread={this.props.resetUnread} />
                                    )
                            }
                        }
                    />
                    
                    <Route
                        path='/chat'
                        render={(match) => {
                            return (
                                        <ChatContainer  {...match} socket={this.state.socket} />
                                    )
                            }
                        }
                    />
                    
                    
                    
                    
                    <Route
                        path='/in-person-session'
                        component={InPersonSessionContainer}
                    />

                    <Route
                        path='/student-profile/:id'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <StudentProfileContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }

                            
                        } }
                    />

                    <Route
                        path='/logs/:courseUserId'
                        component={Logs}
                    />

                    <Route
                        path='/logs'
                        component={Logs}
                    />

                    <Route
                        path='/student-profile'
                        component={StudentProfileContainer}
                    />
                    
                    <Route 
                        path='/student-course/:profileId/:courseId/:subjectId'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <StudentProgressContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }}
                    />
                    
                    <Route 
                        path='/student-course/:profileId/:courseId'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <StudentProgressContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }}
                    />


                    <Route
                        path='/student-course'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <StudentProgressContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }}
                    />
                    <Route
                        path='/challenges'
                        component={ChallengesContainer}
                    />
                    <Route
                        path='/settings/:view'
                        component={SettingsContainer}
                    />
                    
                    <Route
                        path='/settings'
                        render={() => {
                            return (
                                <Redirect
                                    to='/settings/personal'
                                    component={SettingsContainer}
                                />
                            )
                        }}
                        />
                        
                    <Route
                        path='/add-lecture/:courseId/:subjectId/:chapterId/:number'
                        render={(props) => {

                           
                                if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                    return (
                                        <EditChapterPartContainer {...props} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
   
                        }}
                    />
                        
                    <Route
                        path='/edit-lecture/:lectureId'
                        render={(props) => {

                           
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <EditChapterPartContainer {...props} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }

                    }}
                    />
                        
                    <Route
                        path='/edit-chapter-part'
                        render={(props) => {

                           
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <EditChapterPartContainer {...props} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }

                    }}
                    />
                    
                    <Route
                        path='/tests/:chapterTestId'
                        render={(props) => {
                            if (this.props.user.user.role === "admin" || this.props.user.user.role === "instructor") {
                                return (
                                    <EditTestContainer {...props} />
                                )
                            }else{
                                return (
                                    <Redirect
                                        to="/dashboard"
                                        component={DashboardContainer}
                                    />
                                )
                            }
                        }}
                        />
                    
                    <Route
                        path='/tests'
                        render={(props) => {
                            if(this.props.user.user.Profile.role === 'student'){
                                return (
                                    <MyTestsContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <EditTestContainer {...props} />
                                )
                            }
                            }}
                    />
                    
                    <Route
                        path='/my-tests/:view'
                        render={(props) => <MyTestsContainer {...props} socket={this.state.socket} />}
                    />
                    
                    <Route
                        path='/my-tests'
                        render={(props) => <MyTestsContainer {...props} socket={this.state.socket} />}
                    />

                    <Route
                        path='/edit-chapter-test/:subjectId/:number'
                        render={(props) => {
                            if(this.props.user.user.Profile.role === 'student'){
                                return (
                                    <EditChapterTestContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <EditTestContainer {...props} />
                                )
                            }
                            }}
                        
                    />

                    <Route
                        path='/edit-chapter-test/:id'
                        render={(props) => {
                            if(this.props.user.user.Profile.role === 'student'){
                                return (
                                    <EditChapterTestContainer {...props} socket={this.state.socket} />
                                )
                            }else{
                                return (
                                    <EditTestContainer {...props} />
                                )
                            }
                            }}
                    />
                    
                    <Route
                        path='/tasks/:courseId'
                        render={(props) => <TaskContainer {...props} socket={this.state.socket} />}
                    />

                    <Route 
                        path='/users/:search/:page'
                        render={(props) => {
                            if(this.props.user.user.role === 'admin'){
                                return <Users />
                            }else{
                                return <Redirect to='/dashboard' />
                            }
                        }}
                    />          

                    <Route 
                        path='/users/:search'
                        render={(props) => {
                            if(this.props.user.user.role === 'admin'){
                                return <Users />
                            }else{
                                return <Redirect to='/dashboard' />
                            }
                        }}
                    />      
                    
                    <Route 
                        path='/users'
                        render={(props) => {
                            if(this.props.user.user.role === 'admin'){
                                return <Users />
                            }else{
                                return <Redirect to='/dashboard' />
                            }
                        }}
                    />

                    <Route
                        path='/tasks/:taskView'
                        render={(props) => <TaskContainer {...props} socket={this.state.socket} />}
                    />

                    <Route
                        path='/tasks'
                        render={(props) => <TaskContainer {...props} socket={this.state.socket} />}
                    />

                    <Route
                        path='/course-admin/:courseId/:subjectId'

                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <CourseAdminContainer {...props} socket={this.state.socket} history={this.props.history} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />      

                    <Route
                        path='/course-admin/:courseId'

                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <CourseAdminContainer {...props} socket={this.state.socket} history={this.props.history} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />

                    <Route
                        path='/course-admin'

                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <CourseAdminContainer {...props} socket={this.state.socket} history={this.props.history} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    <Route
                        path='/settings-admin'
                        render={
                            () => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <SettingsAdminContainer />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    <Route
                        path='/people'
                        render={
                            () => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <PeopleManager />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    <Route
                        path='/strategy/:courseId'
                        exact={true}
                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <StrategyManagementContainer {...props} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />
                    <Route
                        path='/strategy'
                        exact={true}
                        render={
                            (props) => {
                                if (this.props.user.user.role === "admin") {
                                    return (
                                        <StrategyManagementContainer {...props} />
                                    )
                                }else{
                                    return (
                                        <Redirect
                                            to="/dashboard"
                                            component={DashboardContainer}
                                        />
                                    )
                                }
                            }}
                    />

                    <Route
                        path={'/subject-test/:id'}
                        component={TestContainer}
                        />

                    <Route
                        path='/test/:id'
                        component={TestContainer}
                    />

                    <Route
                        path='/course-notifications/:courseUserId'
                        component={Notifications}
                        />

                    <Route
                        path='/course-notifications'
                        component={Notifications}
                        />


                    <Route
                        path='/red-flags/:courseUserId'
                        component={Flags}
                    />
                    <Route
                        path='/red-flags'
                        component={Flags}
                    />
                    


                    {/*all forms as one view realization*/}
                    <Route
                        path='/on-boarding'
                        component={OnBoardingContainer}
                    />
                    
                    <Route
                        path='/onboarding/:courseUserId'
                        component={OnBoardingContainer}
                    />


                    {/*fix it when two or more courses are open. Add redirects*/}

                    <Route
                        path='/video/:courseId/:subjectId/:id'
                        render={(props) => <VideoItemContainer {...props} socket={this.state.socket} />}
                    />

                    <Route
                        path='/video/item/:id'
                        render={(props) => <VideoItemContainer {...props} socket={this.state.socket} />}
                    />

                    <Route
                        exact
                        path='/video/:courseId/:name'
                        render={(props) => <VideoContainer {...props} socket={this.state.socket} />}
                    />
                    <Route
                        exact
                        path='/video/:name'
                        render={(props) => <VideoContainer {...props} socket={this.state.socket} />}
                    />
                    
                    {/*fix it when two or more courses are open. Add redirects*/}


                    <Route path = "*" component = {NotFound}/>
                </Switch>
                </div>
                {this.props.profile.role === 'student' ?
                <Syllabus />
                : null}
                <About />
                </ErrorBoundary>
                <NotificationContainer/>

                <footer className="main-footer" id="footer">
                    <div className="pull-right hidden-xs footer-rightside"> <a href="#nogo">Terms of Service</a> | <a href="#nogo">Privacy Policy</a></div>
                    <span>
                    	<img src={logo} className="footerLogo" />
                    	<span className="footer-rightside">
                    		Copyright © 2019  99point9, Inc.
                    		All rights reserved.
                    	</span>
                    </span>
                </footer>
            </div>
        )
        
    }
}


App.propTypes = {
    collapsed: PropTypes.bool,
    expandedOnHover: PropTypes.bool,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js